module.exports = __webpack_public_path__ + "img/history-first-shop.308f081b.png";